/* unplugin-vue-components disabled */import { render } from "./fushi.vue?vue&type=template&id=1b6d94bf&scoped=true"
import script from "./fushi.vue?vue&type=script&lang=js"
export * from "./fushi.vue?vue&type=script&lang=js"

import "./fushi.vue?vue&type=style&index=0&id=1b6d94bf&lang=scss&scoped=true"

import exportComponent from "/Users/admin/Desktop/project/klb/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b6d94bf"]])

export default __exports__